/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CurrencyFromJSON, CurrencyToJSON } from './Currency';
import { LegalDocumentVersionsFromJSON, LegalDocumentVersionsToJSON } from './LegalDocumentVersions';
/**
 * Check if a given object implements the SrcApiPurchasesCheckoutRequest interface.
 */
export function instanceOfSrcApiPurchasesCheckoutRequest(value) {
    if (!('cancelUrl' in value) || value['cancelUrl'] === undefined)
        return false;
    if (!('packageId' in value) || value['packageId'] === undefined)
        return false;
    if (!('successUrl' in value) || value['successUrl'] === undefined)
        return false;
    return true;
}
export function SrcApiPurchasesCheckoutRequestFromJSON(json) {
    return SrcApiPurchasesCheckoutRequestFromJSONTyped(json, false);
}
export function SrcApiPurchasesCheckoutRequestFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'cancelUrl': json['cancelUrl'],
        'currency': json['currency'] == null ? undefined : CurrencyFromJSON(json['currency']),
        'legalDocumentVersions': json['legalDocumentVersions'] == null ? undefined : LegalDocumentVersionsFromJSON(json['legalDocumentVersions']),
        'packageId': json['packageId'],
        'successUrl': json['successUrl'],
        'tosAcceptedAt': json['tosAcceptedAt'] == null ? undefined : json['tosAcceptedAt'],
        'withdrawalWaiverAt': json['withdrawalWaiverAt'] == null ? undefined : json['withdrawalWaiverAt'],
    };
}
export function SrcApiPurchasesCheckoutRequestToJSON(json) {
    return SrcApiPurchasesCheckoutRequestToJSONTyped(json, false);
}
export function SrcApiPurchasesCheckoutRequestToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'cancelUrl': value['cancelUrl'],
        'currency': CurrencyToJSON(value['currency']),
        'legalDocumentVersions': LegalDocumentVersionsToJSON(value['legalDocumentVersions']),
        'packageId': value['packageId'],
        'successUrl': value['successUrl'],
        'tosAcceptedAt': value['tosAcceptedAt'],
        'withdrawalWaiverAt': value['withdrawalWaiverAt'],
    };
}
